import { useNavigate } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'
import { Construction, ArrowLeft, CheckCircle } from 'lucide-react'
import { learnerProfileKey } from '@/hooks/learner/useLearnerProfile'
import { TestLayout } from '@/components/learner/test'

export default function AiqTest() {
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const handleDevComplete = async () => {
    const helper = (window as unknown as {
      __lcOnboarding?: { setAiqCompleted?: (done: boolean) => void }
    }).__lcOnboarding
    helper?.setAiqCompleted?.(true)
    await queryClient.invalidateQueries({ queryKey: learnerProfileKey })
    navigate('/my/today')
  }

  return (
    <TestLayout>
      <Construction className="size-20 text-lc-purple-900 mb-4" />
      <h1 className="text-lc-headline-2 text-lc-gray-900 mb-2">AIQ 테스트</h1>
      <p className="text-lc-body-3 text-lc-gray-600 mb-6">AIQ 테스트를 준비하고 있어요!</p>
      <button
        onClick={() => navigate(-1)}
        className="flex items-center gap-2 px-4 py-2 text-lc-caption-1 text-lc-gray-700 border border-lc-gray-200 rounded-lc-md hover:bg-lc-gray-100"
      >
        <ArrowLeft className="size-4" />
        돌아가기
      </button>
      {import.meta.env.DEV && (
        <button
          onClick={handleDevComplete}
          className="mt-3 flex items-center gap-2 px-4 py-2 text-lc-caption-1 text-white bg-lc-purple-900 rounded-lc-md hover:bg-lc-purple-dark"
        >
          <CheckCircle className="size-4" />
          AIQ 완료 처리 (개발용)
        </button>
      )}
    </TestLayout>
  )
}
